import React from 'react';
import { Facebook, Instagram, Linkedin, MapPin, Mail, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 py-12 border-t border-gray-800" data-id="element-239" data-mp="3ggtz0kj4bn6a">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-240" data-mp="32ovvqqc38li1">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-241" data-mp="36p6cmy1f4wbo">
          {/* Company Info */}
          <div data-id="element-242" data-mp="3ufa6idot1hph">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-243" data-mp="3uesczotj1hl9">
              Desert Sage Seminars
            </h3>
            <div className="space-y-3 text-sm" data-id="element-244" data-mp="37fsp0xcko14">
              <p className="flex items-start" data-id="element-245" data-mp="3lecaahklyehg">
                <MapPin className="w-5 h-5 mr-3 text-brand-purple-400 flex-shrink-0" data-id="element-246" data-mp="3ldaphldsidmj" />
                <span data-id="element-247" data-mp="3qcnjqr6zqmz5">Phoenix, Arizona</span>
              </p>
              <p className="flex items-center" data-id="element-248" data-mp="29z6tk9nn6feu">
                <Phone className="w-5 h-5 mr-3 text-brand-purple-400 flex-shrink-0" data-id="element-249" data-mp="29ydvdx2r0y8b" />
                <a href="tel:6023776207" className="hover:text-white" data-id="element-250" data-mp="2eyjprl0ekyu3">
                  602-377-6207
                </a>
              </p>
              <p className="flex items-center" data-id="element-251" data-mp="3l9sin4pzgsoh">
                <Mail className="w-5 h-5 mr-3 text-brand-purple-400 flex-shrink-0" data-id="element-252" data-mp="3gaz213feglk3" />
                <a href="mailto:CustomerService@DesertSageSeminars.com" className="hover:text-white" data-id="element-253" data-mp="3v7gfq1b2ac9t">
                  CustomerService@DesertSageSeminars.com
                </a>
              </p>
            </div>
            <div className="mt-6 flex space-x-4" data-id="element-254" data-mp="80xjq7w8kzj3">
              <a href="https://www.facebook.com/DesertSageSeminars/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Facebook" data-id="element-255" data-mp="34patc8mu2kd">
                <Facebook className="w-5 h-5" data-id="element-256" data-mp="qt067zvk7a19" />
              </a>
              <a href="https://instagram.com/desertsageseminars/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Instagram" data-id="element-257" data-mp="qr5i6cozr1sy">
                <Instagram className="w-5 h-5" data-id="element-258" data-mp="ys3egbxlyuyz" />
              </a>
              <a href="https://www.linkedin.com/company/desert-sage-seminars" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-259" data-mp="13s98tzv9ivkr">
                <Linkedin className="w-5 h-5" data-id="element-260" data-mp="1hjnr24hcisqr" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-261" data-mp="1mkju6ftviav4">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-262" data-mp="1mhxrathxgjj8">Quick Links</h3>
            <ul className="space-y-2 text-sm" data-id="element-263" data-mp="1ri3kwf7rcg3y">
              <li data-id="element-264" data-mp="3obom7czpxdfz">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-265" data-mp="3oc6q8vsmgvyg">
                  On-Demand Classes
                </a>
              </li>
              <li data-id="element-266" data-mp="2afwzir5zft1r">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-267" data-mp="2ah85mxmwhcw1">
                  Zoom Classes
                </a>
              </li>
              <li data-id="element-268" data-mp="21kfn3yxjdjua">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-269" data-mp="1wnyzd5u917hq">
                  In-Person Classes
                </a>
              </li>
              <li data-id="element-270" data-mp="2pbuw2ajtizei">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-271" data-mp="2pdfptxyb6ebb">
                  Class Schedule
                </a>
              </li>
              <li data-id="element-272" data-mp="2fdf465cyvm3y">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-273" data-mp="2fgazrn1cdyp8">
                  My Account
                </a>
              </li>
              <li data-id="element-274" data-mp="1414ei7tis63q">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-275" data-mp="2rvr5f9fqaecp">
                  Contact Support
                </a>
              </li>
            </ul>
          </div>

          {/* Certifications */}
          <div data-id="element-276" data-mp="2isyi1h9o2ms5">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-277" data-mp="2nu5ond02pfx8">Accreditation</h3>
            <div className="space-y-4 text-sm" data-id="element-278" data-mp="2ns1o951duz1p">
              <div className="p-4 bg-gray-800 rounded-lg border border-gray-700" data-id="element-279" data-mp="3bjgtb5kjnugn">
                <p className="font-semibold text-white mb-1" data-id="element-280" data-mp="3fltxhpjn7kbb">
                  ADRE School #S06-0002
                </p>
                <p className="text-xs text-gray-400" data-id="element-281" data-mp="31khibgcb3mqh">
                  Approved by the Arizona Department of Real Estate
                </p>
              </div>
              <div className="p-4 bg-gray-800 rounded-lg border border-gray-700" data-id="element-282" data-mp="1q6dqogt6yaol">
                <p className="font-semibold text-white mb-1" data-id="element-283" data-mp="1q8gm5gd44w0p">REEA Member</p>
                <p className="text-xs text-gray-400" data-id="element-284" data-mp="1v71phonnvvtd">
                  Real Estate Educators Association
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-285" data-mp="1im368j3o5pht">
          <p data-id="element-286" data-mp="1wk9ur8mqad4t">
            &copy; {new Date().getFullYear()} Desert Sage Seminars. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-287" data-mp="13xgo69mnqjmw">
            <a href="/PrivacyStatement" className="hover:text-white" data-id="element-288" data-mp="13vvu0l4992pk">
              Privacy Policy
            </a>
            <a href="/PrivacyStatement#terms" className="hover:text-white" data-id="element-289" data-mp="zuk1o7tzy3do">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}